import type { ReactNode } from 'react';
import { cn } from './cn';

interface StatTileProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'neutral' | 'ok' | 'warn' | 'danger' | 'info';
  icon?: ReactNode;
  className?: string;
}

const VALUE_TONE: Record<NonNullable<StatTileProps['tone']>, string> = {
  neutral: 'text-slate-100',
  ok: 'text-ok',
  warn: 'text-warn',
  danger: 'text-danger',
  info: 'text-brand-400',
};

/** Compact KPI tile — big metric value over a label, with an optional hint. */
export function StatTile({ label, value, hint, tone = 'neutral', icon, className }: StatTileProps) {
  return (
    <div className={cn('panel p-5', className)}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-text-muted">{label}</span>
        {icon ? <span className="text-text-muted">{icon}</span> : null}
      </div>
      <div className={cn('metric mt-2 text-2xl font-semibold', VALUE_TONE[tone])}>{value}</div>
      {hint ? <div className="mt-1 text-xs text-text-secondary">{hint}</div> : null}
    </div>
  );
}
